import React, { useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const PRODUCTS = [
  { key: "mutual_fund", label: "Mutual Fund" },
  { key: "shares_bond", label: "Shares & Bond" },
  { key: "fixed_deposit", label: "Fixed Deposit" },
  { key: "other_assets", label: "Other Assets" },
];

function EmptyTable({ columns, title }) {
  return (
    <div className="card shadow-sm mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
      {title && (
        <div className="card-header bg-white border-bottom" style={{ fontWeight: "600", color: "#0f172a" }}>
          {title}
        </div>
      )}
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead style={{ background: "#f8fafc" }}>
            <tr>
              {columns.map((col) => (
                <th key={col.key} style={{ padding: "12px 16px", color: "#64748b", fontWeight: "600", fontSize: "13px" }}>
                  {col.label}
                  <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={columns.length} className="text-center py-5" style={{ color: "#94a3b8" }}>
                <i className="fa fa-exclamation-triangle d-block mb-2" style={{ fontSize: "2rem" }} aria-hidden />
                No data available.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function HoldingPanel({ title }) {
  return (
    <div className="card shadow-sm h-100" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "hidden" }}>
      <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between" style={{ fontWeight: "600", color: "#0f172a" }}>
        {title}
        <span>
          <i className="fa fa-sort me-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
        </span>
      </div>
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead style={{ background: "#f8fafc" }}>
            <tr>
              <th style={{ padding: "12px 16px", color: "#64748b", fontWeight: "600", fontSize: "13px" }}>
                Amount <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
              </th>
              <th style={{ padding: "12px 16px", color: TEAL, fontWeight: "600", fontSize: "13px" }}>
                Share(%) <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={2} className="text-center py-5" style={{ color: "#94a3b8" }}>
                <i className="fa fa-exclamation-triangle d-block mb-2" style={{ fontSize: "2rem" }} aria-hidden />
                No data available.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function AssetAllocation() {
  const [investor, setInvestor] = useState("all_selected");
  const [source, setSource] = useState("all");
  const [products, setProducts] = useState(() =>
    PRODUCTS.reduce((acc, p) => ({ ...acc, [p.key]: true }), {})
  );
  const [applying, setApplying] = useState(false);
  const [showHolding, setShowHolding] = useState(false);

  const toggleProduct = (key) => {
    setProducts((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleApply = () => {
    setApplying(true);
    setTimeout(() => setApplying(false), 600);
  };

  const handleExportPdf = () => {
    // TODO: export PDF
  };
  const handleExportXls = () => {
    // TODO: export Excel
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {!showHolding && (
        <>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <h3 className="mb-2 text-primary">Asset Allocation</h3>
                <nav
                  aria-label="breadcrumb"
                  style={{ "--bs-breadcrumb-divider": "none" }}
                >
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <NavLink to="/overview">Dashboard</NavLink> /
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/reports/asset-allocation">Reports</NavLink> /
                    </li>
                    <li className="breadcrumb-item active">Asset Allocation</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>

        <div className="card shadow-sm p-4 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}>
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-3">
            <div>
      
            </div>
            <div className="d-flex align-items-center gap-2">
              <button
                type="button"
                className="btn btn-sm border"
                onClick={handleExportPdf}
                title="Export PDF"
                style={{ borderRadius: "8px" }}
              >
                <i className="fa fa-file-pdf text-danger" /> <i className="fa fa-download small" />
              </button>
              <button
                type="button"
                className="btn btn-sm border"
                onClick={handleExportXls}
                title="Export Excel"
                style={{ borderRadius: "8px" }}
              >
                <i className="fa fa-file-excel text-success" /> <i className="fa fa-download small" />
              </button>
            </div>
          </div>

          {/* Info banner */}
          <div
            className="d-flex align-items-center gap-2 p-3 mb-4 rounded"
            style={{ background: "#e0f2fe", color: "#0369a1", borderRadius: "8px" }}
          >
            <i className="fa fa-info-circle" style={{ fontSize: "1.1rem" }} aria-hidden />
            <span>View detailed allocation analysis of your current investments.</span>
          </div>

          {/* Filters + Choose Products + Apply */}
          <div className="d-flex flex-wrap align-items-end gap-3 mb-4">
            <div>
              <label className="form-label small text-muted mb-1">Investor :</label>
              <select
                className="form-select form-select-sm"
                value={investor}
                onChange={(e) => setInvestor(e.target.value)}
                style={{ width: "160px", borderRadius: "8px", border: "1px solid #e2e8f0" }}
              >
                <option value="all_selected">All Selected</option>
                <option value="primary">Primary</option>
              </select>
            </div>
            <div>
              <label className="form-label small text-muted mb-1">Source :</label>
              <select
                className="form-select form-select-sm"
                value={source}
                onChange={(e) => setSource(e.target.value)}
                style={{ width: "140px", borderRadius: "8px", border: "1px solid #e2e8f0" }}
              >
                <option value="all">All</option>
              </select>
            </div>
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <span className="small fw-semibold text-muted">Choose Products:</span>
              {PRODUCTS.map((p) => (
                <label key={p.key} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={products[p.key]}
                    onChange={() => toggleProduct(p.key)}
                    style={{ accentColor: TEAL, width: 16, height: 16 }}
                  />
                  <span className="small" style={{ color: "#475569" }}>{p.label}</span>
                </label>
              ))}
            </div>
            <button
              type="button"
              className="btn btn-sm px-4"
              onClick={handleApply}
              disabled={applying}
              style={{
                background: TEAL,
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "600",
              }}
            >
              {applying ? (
                <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
              ) : null}
              Apply
            </button>
          </div>
        </div>

        {/* Tables */}
        <div className="row">
          <div className="col-12">
            <EmptyTable
              title="Product Allocation"
              columns={[
                { key: "product", label: "Product" },
                { key: "amount", label: "Amount" },
                { key: "share", label: "Share(%)" },
              ]}
            />
          </div>
          <div className="col-12">
            <EmptyTable
              title="Investor Allocation"
              columns={[
                { key: "investor", label: "Investor" },
                { key: "amount", label: "Amount" },
                { key: "share", label: "Share(%)" },
              ]}
            />
          </div>
          <div className="col-md-6">
            <EmptyTable
              title="Sub Category Allocation"
              columns={[
                { key: "sub_category", label: "Sub Category" },
                { key: "amount", label: "Amount" },
                { key: "share", label: "Share(%)" },
              ]}
            />
          </div>
          <div className="col-md-6">
            <EmptyTable
              title="Fund Allocation"
              columns={[
                { key: "fund", label: "Fund" },
                { key: "amount", label: "Amount" },
                { key: "share", label: "Share(%)" },
              ]}
            />
          </div>
          <div className="col-12">
            <EmptyTable
              title="Category"
              columns={[
                { key: "scheme_name", label: "Scheme Name" },
                { key: "sub_category", label: "Sub Category" },
                { key: "debt", label: "Debt" },
                { key: "equity", label: "Equity" },
                { key: "global_equity", label: "Global Equity" },
                { key: "gold", label: "Gold" },
                { key: "real_estate", label: "Real Estate" },
                { key: "other", label: "Other" },
                { key: "total", label: "Total" },
                { key: "share", label: "Share(%)" },
              ]}
            />
          </div>
          <div className="col-12">
            <EmptyTable
              title="Equity Cap for Mutual Fund"
              columns={[
                { key: "scheme_name", label: "Scheme Name" },
                { key: "sub_category", label: "Sub Category" },
                { key: "large_cap", label: "Equity Large Cap" },
                { key: "mid_cap", label: "Equity Mid Cap" },
                { key: "small_cap", label: "Equity Small Cap" },
                { key: "total", label: "Total" },
                { key: "share", label: "Share(%)" },
              ]}
            />
          </div>
          <div className="col-12">
            <EmptyTable
              columns={[
                { key: "scheme_scrip", label: "Scheme/Scrip" },
                { key: "amount", label: "Amount" },
                { key: "share", label: "Share(%)" },
              ]}
            />
          </div>
        </div>

        {/* Show Holding */}
        <div className="d-flex justify-content-center py-4">
          <button
            type="button"
            className="btn px-5 py-2"
            style={{
              background: TEAL,
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontWeight: "600",
              fontSize: "15px",
            }}
            onClick={() => setShowHolding(true)}
          >
            Show Holding
          </button>
        </div>
        </>
        )}

        {/* Holding view (when Show Holding is clicked) */}
        {showHolding && (
          <div className="container-fluid py-3">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{ borderRadius: "8px", fontWeight: "600" }}
                onClick={() => setShowHolding(false)}
              >
                Back to Asset Allocation
              </button>
            </div>

            <h5 className="mt-4 mb-3" style={{ color: "#0f172a", fontWeight: "600" }}>Holding</h5>
            <div className="row g-4">
              <div className="col-md-6">
                <HoldingPanel title="By Scrip (Top 10)" />
              </div>
              <div className="col-md-6">
                <HoldingPanel title="By Paper (Top 10)" />
              </div>
              <div className="col-md-6">
                <HoldingPanel title="By Sector (Top 10)" />
              </div>
              <div className="col-md-6">
                <HoldingPanel title="By Rating (Top 10)" />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
